import $ from "jquery"
import CryptoJS from "crypto-js";
import Species from "@/assets/js/apiObj/Species"
import Intake from "@/assets/js/apiObj/Intake"
import Medical from "@/assets/js/apiObj/Medical"
import Parameters from "@/assets/js/apiObj/parameters"
import Files from "@/assets/js/apiObj/files"
import Label from "@/assets/js/apiObj/label"
import Users from "@/assets/js/apiObj/users"
import Ftm from "@/assets/js/apiObj/ftm"
import Inv from "@/assets/js/apiObj/inv"
import SpeciesItem from "@/assets/js/apiObj/speciesItem"
import Rec from "@/assets/js/apiObj/rec"
import Pres from "@/assets/js/apiObj/pres"
import Care from "@/assets/js/apiObj/care"
import Tm from "@/assets/js/apiObj/tm"
import Surg from "@/assets/js/apiObj/surg"
import Diss from '@/assets/js/apiObj/diss'
import Exam from '@/assets/js/apiObj/exam'
import Mis from '@/assets/js/apiObj/mis'
import Ft from '@/assets/js/apiObj/ft'
import Com from '@/assets/js/apiObj/com'
import Mf from '@/assets/js/apiObj/mf'
import Shift from '@/assets/js/apiObj/shift'
import AckMedical from '@/assets/js/apiObj/ackMedical'
import shareds from '@/assets/js/shared'
class ApiService {
    //物件建立時產生
    constructor(vue = null) {
        const hostname = window.location.hostname;

        if (
            hostname.startsWith("192.168.") &&
            process.env.VUE_APP_TEST_ENV === "production"
        ) {
            this.url = process.env.VUE_APP_LOCAL_API_URL; // 使用本地 API URL
        } else {
            this.url = process.env.VUE_APP_API_URL; // 使用預設 API URL
        }
        // this.url = process.env.VUE_APP_API_URL
        this.key = process.env.VUE_APP_TOKEN_KEY
        this.header = {}
        this.isDecryption = false
        this.userData = {}
        this.token = ""
        this.router = null//vue.$router; // 保存 router 實例
        this.debug = vue ? vue.$debug : null; // 保存 router 實例
        this.store = vue ? vue.$store : null
        this.shared = new shareds()

        //初始化API Modules物件
        this.species = new Species(this)
        this.intake = new Intake(this)
        this.medical = new Medical(this)
        this.parameters = new Parameters(this)
        this.files = new Files(this)
        this.label = new Label(this)
        this.users = new Users(this)
        this.ftm = new Ftm(this)
        this.inv = new Inv(this)
        this.rec = new Rec(this)
        this.care = new Care(this)
        this.pres = new Pres(this)
        this.speciesItem = new SpeciesItem(this)
        this.tm = new Tm(this)
        this.surg = new Surg(this)
        this.diss = new Diss(this)
        this.exam = new Exam(this)
        this.mis = new Mis(this)
        this.ft = new Ft(this)
        this.com = new Com(this)
        this.mf = new Mf(this)
        this.shift = new Shift(this)
        this.ackMedical = new AckMedical(this)
    }

    init() { //初始化header
        this.header = localStorage.getItem('wildone_account') ? {
            token: localStorage.getItem('wildone_account')
        } : {}
    }
    //user Token 處理成32長度
    getUserToken(token) {
        let hToken = token.substr(0, 16)
        let fToken = token.substr(token.length - 16, token.length)
        return hToken + fToken
    }
    setToken(token) {
        this.token = token;
        this.header = {
            token: this.token
        }
    }
    getToken() {
        return this.token;
    }
    //解密
    AES_ECB_DECRYPT(token) {
        if (token == '') {
            return;
        }
        var decrypt = CryptoJS.AES.decrypt(
            token,
            CryptoJS.enc.Utf8.parse(this.key),
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );
        return decrypt.toString(CryptoJS.enc.Utf8)
    }
    //資料加密
    AES_ECB_ENCRYPT(parameter) {
        let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(JSON.stringify(parameter)), CryptoJS.enc.Utf8.parse(this.key), {
            iv: CryptoJS.enc.Utf8.parse(this.iv),
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64)
    }
    //api請求body資料加密
    apiDataEncrypt(parameter) {
        if (this.isDecryption) { //需要加密
            parameter = {
                data: this.AES_ECB_ENCRYPT(parameter)
            }
            parameter = JSON.stringify(parameter)
        } else { //資料不需要加密
            // parameter = JSON.stringify(parameter)
        }
        return parameter
    }
    //api回應資料解密
    apiDataDecrypt(parameter) {
        if (this.isDecryption) { //需要解密
            parameter = JSON.parse(this.AES_ECB_DECRYPT(parameter.data))
        }
        // parameter.code = -1000
        //處理強制登出問題
        if (parameter.code <= -1000) {
            this.store.state.actionResult.show({ status: 'fail', massage: `[${parameter.code}]您的帳號已登出，或者帳號有更動，請重新登入` })
            this.router.push(`/login`)
        }
        return parameter
    }
    //處理login&註冊時產生token
    userInputEncrypt() {
        let token = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex)
        return token
    }
    loginSuccessHandle(token = null, per = null) {
        console.log(`token=`, token)
        localStorage.setItem('wildone_account', token)
        localStorage.setItem('wildone_per', per)
    }
    //get加密
    getMethodEncryp(parameter = null) {
        if (parameter == null) {
            return ''
        }
        if (this.isDecryption) { //需要加密
            parameter = {
                data: this.AES_ECB_ENCRYPT(parameter)
            }
            parameter = "data=" + parameter
        } else { //資料不需要加密
            // parameter = JSON.stringify(parameter)
            let url = ''
            Object.keys(parameter).forEach((key) => {
                url = url + key + '=' + parameter[key] + '&'
            });
            parameter = url.substring(0, url.length - 1);
        }
        return parameter
    }
    //執行POST
    postApi(data) {
        let self = this
        this.init()
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'POST',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            // contentType : 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function (res) {
                self.debug(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                data.success(res)
            },
            xhr: function () {
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function (progressEvent) { // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete * 100);
                        if (data.progress) {
                            // self.debug("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total); 
                            data.progress({
                                mag: "上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded / progressEvent.total,
                                loaded: progressEvent.loaded,
                                total: progressEvent.total,
                                percentComplete: percentComplete,
                                percentVal: percentVal
                            })
                        }
                    }
                }, false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function (err) {
                self.debug(err)
                data.error({ code: 500, msg: '伺服器請求異常' })
            }
        })
    }
    postFormDataApi(data) {
        let self = this
        this.init()
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'POST',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            data: data.parameter,  // 將表單資料用打包起來送出去
            contentType: false,
            cache: false,
            processData: false,
            success: function (res) {
                // self.debug(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                data.success(res)
            },
            xhr: function () {
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function (progressEvent) { // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete * 100);
                        if (data.progress) {
                            // self.debug("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded/progressEvent.total); 
                            data.progress({
                                mag: "上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + progressEvent.loaded / progressEvent.total,
                                loaded: progressEvent.loaded,
                                total: progressEvent.total,
                                percentComplete: percentComplete,
                                percentVal: percentVal
                            })
                        }
                    }
                }, false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function (err) {
                // self.debug(err)
                data.error({ code: 500, msg: '伺服器請求異常' })
            }
        })
    }
    //執行PUT
    putApi(data) {
        let self = this
        this.init()
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'PUT',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            contentType: 'application/json; charset=utf-8', // 要送到server的資料型態
            data: self.apiDataEncrypt(data.parameter),
            success: function (res) {
                // self.debug(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                data.success(res)
            },
            xhr: function () {
                var xhr = new window.XMLHttpRequest(); // 建立xhr(XMLHttpRequest)物件
                xhr.upload.addEventListener("progress", function (progressEvent) { // 監聽ProgressEvent
                    if (progressEvent.lengthComputable) {
                        var percentComplete = progressEvent.loaded / progressEvent.total;
                        var percentVal = Math.round(percentComplete * 100);
                        if (data.progress) {
                            self.debug("上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + (progressEvent.loaded / progressEvent.total) * 100 + '%');
                            data.progress({
                                mag: "上傳進度為：" + progressEvent.loaded + " of " + progressEvent.total + " bytes" + '；百分比為：' + (progressEvent.loaded / progressEvent.total) * 100 + '%',
                                loaded: progressEvent.loaded,
                                total: progressEvent.total,
                                percentComplete: percentComplete,
                                percentVal: percentVal
                            })
                        }
                    }
                }, false);
                return xhr; // 注意必須將xhr(XMLHttpRequest)物件回傳
            },
            error: function (err) {
                // self.debug(err)
                data.error({ code: 500, msg: '伺服器請求異常' })
            }
        })
    }
    //執行GET
    getApi(data) {
        let self = this
        this.init()
        if (data.parameter) {
            data.url = data.url + "?" + this.getMethodEncryp(data.parameter)
        }
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'GET',               // 使用 GET 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            success: function (res) {
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                data.success(res)
            },
            error: function (err) {
                self.debug(err)
                data.error({ code: 500, msg: '伺服器請求異常' })
            }
        })
    }

    //執行DELECT
    delApi(data) {
        let self = this
        this.init()
        $.ajax({
            url: data.url,              // 要傳送的頁面
            method: 'DELETE',               // 使用 POST 方法傳送請求
            dataType: 'json',             // 回傳資料會是 json 格式
            headers: self.header,
            data: data.parameter,  // 將表單資料用打包起來送出去
            contentType: false,
            cache: false,
            processData: false,
            success: function (res) {
                self.debug(res)
                // 成功以後會執行這個方法
                res = self.apiDataDecrypt(res)
                data.success(res)
            },
            error: function (err) {
                self.debug(err)
                data.error({ code: 500, msg: '伺服器請求異常' })
            }
        })
    }

    /*
    api區
    */
    //取得測試資料
    getTestTableAPI(parameter, callback) {
        //呼叫post方法
        this.getApi({
            url: this.url + "patient/list",
            parameter: parameter,
            success: function (res) {
                callback(res)
            }
        })
    }

    async simulationAPI() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ code: 200, msg: 'success' })
            }, 1000);
        })
    }

    //user - 1.1登入 f
    async login(parameter) {
        //處理密碼加密
        //呼叫post方法
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "users/login",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }
    //產線管理 - 1.01取得產線列表
    async getProductionLine(parameter) {
        return new Promise((resolve, reject) => {
            this.getApi({
                url: this.url + "productionLine/getProductionLine",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }

    async addProductionLine(parameter) {
        return new Promise((resolve, reject) => {
            this.postFormDataApi({
                url: this.url + "productionLine/addProductionLine",
                parameter: parameter,
                success: function (res) {
                    resolve(res)
                },
                error: (err) => [
                    reject(err)
                ]
            })
        })
    }


}
export default ApiService